// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"
import UrlConfig from "@/utils/UrlConfig"
import { TYPESENSE_REQUEST_TIMEOUT_MS } from "@/utils/typesenseRetry"
import { normalizeVanities } from "@/utils/typesenseApiKeyCacheKey"

export function searchAndFiltersRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns the scoped typesense API key
     * @param tenantId targeted tenant
     * @param vanity targeted vanity (single string or array of objects { label: string, value: string, checked: boolean })
     * @returns
     */
    async getTypesenseApiKey(
      tenantId: string,
      vanity: string | Array<string | { label: string, value: string, checked: boolean }>,
    ): Promise<TypesenseApiKeyResponse> {
      const filterValue = normalizeVanities(vanity).map(v => `backoffice_vanity:${v}`).join(",")

      return fetch<TypesenseApiKeyResponse>(`${UrlConfig.PATH_BASE_OFFER_SERVICE}/search/api-key`, {
        timeout: TYPESENSE_REQUEST_TIMEOUT_MS,
        headers: {
          "Accept": "application/json",
          "X-Tenant-Id": tenantId,
        },
        params: {
          filter: filterValue,
        },
      })
    },
  }
}
